<template>
    <v-main>
    <v-container fluid style="height:100%;">
        <v-snackbar
        :timeout="5000"
        :value="snack"
        absolute
        top
        :color="scolor"
        outlined
        center
        >
            {{stext}}
        </v-snackbar>
        <v-row align="center" justify="space-around" style="height:100%">
            <v-col class="px-15 pb-10 pt-10" md="12" xs="12" align="center" >
                <v-card class="rounded-xl"  elevation="10" max-width="1200">
                    <v-row class="pa-5" align="center" justify="space-around">
                        <v-col md="6" xs="12">
                            <div>
                                <v-img
                                :src="require('../assets/sigma.png')"
                                class="my-3"
                                contain
                                height="100"
                                elevation="5"
                                />
                            </div>
                            <div>
                                <v-img
                                :src="require('../assets/stock-img.webp')"
                                class="my-3 rounded-r-0"
                                gradient="to top right, rgba(100,115,201,.33), rgba(25,32,72,.7)"
                                contain
                                />
                            </div>
                        </v-col>
                        <v-col align="left" md="6" xs="12">
                            <v-tabs v-model="tabs" @change="close">
                                <v-tabs-slider color="#00c7ff"></v-tabs-slider>
                                <v-tab>Login</v-tab>
                                <v-tab>Register</v-tab>
                            </v-tabs>
                            <v-tabs-items v-model="tabs">
                                    <v-tab-item >
                                        <div>
                                            <v-card class="p-5" style="border-radius: 0;">
                                                <div class="pt-3">
                                                </div>
                                                <v-form>
                                                    <v-text-field label="Email" filled prepend-inner-icon="mdi-account" :rules="emailRules" v-model="email"></v-text-field>
                                                    <v-text-field label="Password" filled prepend-inner-icon="mdi-lock" :rules="req" type="password" v-model="password"></v-text-field>
                                                    <v-btn block large @click="login" :loading="loading" class="gradient-button"> Login </v-btn>
                                                    <div class="d-flex justify-center">
                                                        <v-btn @click="dialog1 = true" text class="mt-3">Forgot Password?</v-btn>
                                                    </div>
                                                </v-form>
                                            </v-card>
                                        </div>
                                    </v-tab-item>
                                    <v-tab-item>
                                        <v-card class="p-5" style="border-radius: 0;">
                                            <div class="pt-3">
                                            </div>
                                            <div>
                                                <v-form>
                                                    <v-text-field label="Name" filled prepend-inner-icon="mdi-account" :rules="req" v-model="name"></v-text-field>
                                                    <v-text-field label="Phone" filled prepend-inner-icon="mdi-phone" :rules="phoneRules" v-model="phone"></v-text-field>
                                                    <v-text-field label="Email" filled prepend-inner-icon="mdi-email" :rules="emailRules" v-model="email"></v-text-field>
                                                    <v-text-field label="Password" filled prepend-inner-icon="mdi-lock" :rules="req" type="password" v-model="password"></v-text-field>
                                                    <v-text-field label="Confirm Password" filled prepend-inner-icon="mdi-lock-outline" :rules="passMatch" type="password" v-model="rpassword"></v-text-field>
                                                    <v-btn block large @click="register" :loading="loading" class="gradient-button"> Register </v-btn>
                                                </v-form>
                                            </div>
                                        </v-card>
                                    </v-tab-item>
                                </v-tabs-items>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-dialog v-model="dialog" max-width="500px" persistent>
                <v-card>
                    <v-card-title>Please Confirm Your Email</v-card-title>
                    <v-card-text>
                        <p>We have sent a confirmation email to {{email}}. Please check your inbox and click on the confirmation link to complete your registration.</p>
                        <v-btn color="primary" @click="close">Close</v-btn>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-row>
        <v-row>
            <v-dialog v-model="dialog1" max-width="500px" persistent>
                <v-card>
                    <v-card-title>
                        Reset Password
                    </v-card-title>
                    <v-card-text>
                        <v-text-field label="Registed Email" v-model="email" outlined></v-text-field>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn :loading="loading" color="primary" @click="resetPassword">Reset</v-btn>
                        <v-btn color="red" @click="close">Close</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
    </v-container>
    </v-main>
</template>

<script>
import {supabase} from '../supabase'
export default {
    data: () => ({
        reg: true,
        valid: true,
        otpWait: false,
        tabs: null,
        otp: null,
        name: '',
        email: '',
        phone: '',
        phoneRules: [
            v => !!v || 'Phone number is required',
            v => /^[6-9]{1}[0-9]{9}$/.test(v) || 'Enter valid phone number',
        ],
        emailRules: [
            v => !!v || 'E-mail is required',
            v => /.+@.+\..+/.test(v) || 'Enter valid email address',
        ],
        req: [
            v => !!v || 'This field is required',
        ],
        password: '',
        rpassword: '',
        loading: false,
        snack: false,
        scolor: '',
        stext: '',
        dialog: false,
        dialog1: false,
    }),

    methods: {
        async login() {
            this.loading = true
            this.$store.commit('SET_M_LOGIN', true)
            let { data, error } = await supabase.auth.signInWithPassword({
                email: this.email,
                password: this.password
            })
            if(!error && data) {
                console.log(data);
                this.snack = true
                this.scolor = 'success'
                this.stext = 'Logged In'
                this.loading = false
            } else {
                console.log(error);
                this.snack = true
                this.scolor = 'error'
                this.stext = error.message
                this.loading = false
            }
        },

        resetPassword() {
            this.loading = true
            supabase.auth.resetPasswordForEmail(this.email, {
                    redirectTo: 'https://positions.sigmaequityresearch.com/update-password',
                }).then(({data, error}) => {
                if(data) {
                    this.snack = true
                    this.scolor = 'success'
                    this.stext = 'Password reset email sent!'
                    this.dialog1 = false
                }
                if(error) {
                    this.snack = true
                    this.scolor = 'error'
                    this.stext = error.message
                }
                this.loading = false
            })
        },

        async register () {
            this.loading = true
            let res = await supabase.from('users')
            .select('email').eq('email', this.email)
            console.log('Check Email:', res.data, 'Error:', res.error);
            if(res.data.length > 0) {
                this.snack = true
                this.scolor = 'error'
                this.stext = 'Email already exists!'
                this.loading = false
                return
            }
            console.log('Check Email:', res.data, 'Error:', res.error);

            let {data, error} = await supabase.auth.signUp({
                email: this.email,
                password: this.password
            })   
            console.log('Register Data:', data, 'Error:', error);
                     
            if(error) {
                this.snack = true
                this.scolor = 'error'
                this.stext = error.message
                this.loading = false
            }
            if (data.user){
                supabase.from('users').insert([
                {name: this.name, phone: this.phone, email: this.email, uid: data.user.id}
                ]).then(({data, error}) => {
                    if(data) {
                        console.log(data);
                    }
                    if(error) {
                        this.snack = true
                        this.scolor = 'error'
                        this.stext = error.message
                        this.loading = false
                    } else {
                        this.snack = true
                        this.scolor = 'success'
                        this.stext = 'User registered successfully!'
                        this.loading = false
                        this.dialog = true
                    }
                })
            }
            this.loading = false
        },

        base64ToBuffer(base64) {
            const binary = atob(base64);
            const bytes = new Uint8Array(binary.length);
            for (let i = 0; i < binary.length; i++) {
            bytes[i] = binary.charCodeAt(i);
            }
            return bytes.buffer;
        },

        bufferToStr(buffer) {
            return new TextDecoder().decode(buffer);
        },

        async importKey(base64Key) {
            const rawKey = this.base64ToBuffer(base64Key);
            return await crypto.subtle.importKey(
            "raw",
            rawKey,
            { name: "AES-GCM" },
            false,
            ["decrypt"]
            );
        },

        async decryptText(base64Data, base64Iv, key) {
            const encryptedData = this.base64ToBuffer(base64Data);
            const iv = new Uint8Array(this.base64ToBuffer(base64Iv));

            const decryptedBuffer = await crypto.subtle.decrypt(
            {
                name: "AES-GCM",
                iv: iv
            },
            key,
            encryptedData
            );

            return this.bufferToStr(decryptedBuffer);
        },

        async autoLogin (keyData, emailData, emailIv, passwordData, passwordIv) {
            try {
                const key = await this.importKey(keyData);
                const decryptedEmail = await this.decryptText(emailData, emailIv, key);
                const decryptedPassword = await this.decryptText(passwordData, passwordIv, key);

                console.log('Decrypted Email:', decryptedEmail);
                console.log('Decrypted Password:', decryptedPassword);

                // Now you can use the decrypted email and password to log in
                this.email = decryptedEmail;
                this.password = decryptedPassword;
                await this.login();
            } catch (error) {
                console.error('Decryption failed:', error);
            }

        },

        close() {
            this.email = null
            this.password = null
            this.name = null   
            this.phone = null
            this.rpassword = null
            this.loading = false
            this.dialog = false
            this.dialog1 = false
        }
    },

    mounted() {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        console.log('URL Params:', urlParams.toString());

        if(urlParams.has('token')) {
            supabase.auth.verifyOtp({ token_hash: urlParams.get('token'), type: 'email'})
        }

        if(urlParams.has('signup')) {
            this.tabs = 1; // Switch to Register tab
        }
        
        if(urlParams.has('re')) {
            const emailData = urlParams.get('l');
            const emailIv = urlParams.get('lIv');
            const passwordData = urlParams.get('d');
            const passwordIv = urlParams.get('dIv');
            const keyData = urlParams.get('y');
            console.log('Key Data:', keyData);
            console.log('Email Data:', emailData);
            console.log('Email IV:', emailIv);
            console.log('Password Data:', passwordData);
            this.autoLogin(keyData, emailData, emailIv, passwordData, passwordIv)
        }
       
    },

    computed: {
        passMatch () {
            return [v => (!!v && v) === this.password ||'Values do not match']
        }
    }
}
</script>